const productDetailsInfo = {}

export default {
  productDetailsInfo
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-cashier/store/state.js